module.exports = __webpack_public_path__ + "img/nav-reference.3ee4fbc0.svg";